//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UseGatewayApiDebug: FeatureFlag = {"Id":"UseGatewayApiDebug","Label":"[10.21]Use Gateway API for debug endpoint","Impact":"When enabled, the /Api/v1/Debug endpoint calls Gateway API for debug information. When disabled, returns internal AccessGov diagnostics including health status, version, environment, and configuration.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
